import { useMutation } from "@tanstack/react-query";
import { imagineStore } from "@/stores/imagine.store";
import { aiServiceUpload } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";

type Props = {
  onSuccess: (data: any, file: File) => void;
  onError: (error: Error, file: File) => void;
  onMutate: (file: File) => void;
};

export function useUploadFiles({ onSuccess, onError, onMutate }: Props) {
  // Read both project ids to prevent react hooks ordering issue.
  const projectId = imagineStore.use.projectId();
  const newProjectId = imagineStore.use.newProjectId();
  const projectIdToUse = projectId ?? newProjectId;

  const { mutate } = useMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      const response = await aiServiceUpload(
        `/api/projects/${projectIdToUse}/upload`,
        formData,
      );

      if (!response.ok) {
        throw await HttpError.fromResponse(response);
      }

      return await response.json();
    },
    retry: 3,
    onSuccess,
    onError,
    onMutate,
  });

  const uploadFiles = async (files: Array<File>) => {
    await Promise.all(files.map((file) => mutate(file)));
  };

  return uploadFiles;
}
